import { useCallback, useEffect } from 'react';
import { CustomImage } from '../index';
import { footerLink } from '@src/utils/keys';
import rightArrow from '@src/assets/icons/icon-rigth-arrow.svg';
import iconFacebook from '@src/assets/icons/icon-facebook.svg';
import iconInstagram from '@src/assets/icons/icon-instagram.svg';
import iconLinkedin from '@src/assets/icons/icon-linkedin.svg';
import iconTwitter from '@src/assets/icons/icon-twitter.svg';
import iconYoutube from '@src/assets/icons/icon-youtube.svg';
import iconAdminFacebook from '@src/assets/icons/icon-admin-facebook.svg';
import iconAdminInstagram from '@src/assets/icons/icon-admin-instagram.svg';
import iconAdminLinkedin from '@src/assets/icons/icon-admin-linkedin.svg';
import iconAdminTwitter from '@src/assets/icons/icon-admin-twitter.svg';
import iconAdminYoutube from '@src/assets/icons/icon-admin-youtube.svg';
import iconLanguageTr from '@src/assets/icons/icon-language-tr.svg';
import iconLanguageEn from '@src/assets/icons/icon-language-en.svg';
import { Text, useText } from '../';
import { Select } from 'antd';
import { useLang } from '@src/context';
import '@src/styles/components/footer.scss';
import { useSelector } from 'react-redux';
import { languageOptions } from '@src/assets/language';
import dayjs from '@src/utils/day';

const { Option } = Select;

const Footer = () => {
  const { languageChange, language } = useLang();

  const ticketOnlineOrderingPlatformLanguage = useText('ticketOnlineOrderingPlatform');
  const { isAdmin } = useSelector((state) => state?.auth);

  const changeTitle = useCallback((text) => {
    document.title = text;
  }, []);

  const handleChange = useCallback(
    (value) => {
      languageChange(value);
    },
    [languageChange],
  );

  useEffect(() => {
    changeTitle(ticketOnlineOrderingPlatformLanguage);
  }, [language, changeTitle, ticketOnlineOrderingPlatformLanguage]);

  return (
    <div className={isAdmin ? 'edenred-footer is-admin' : 'edenred-footer'} id={'edenred-footer'}>
      {!isAdmin && (
        <>
          <a
            className="link"
            href={'https://mailing.ticket.com.tr/Marketing/2024/RCB/RedClubBusiness.html'}
            target="_blank"
            rel="noreferrer"
          >
            <div className="campaigns">
              <span className="title">
                <Text t="redClubCampaigns" />
              </span>
              <CustomImage src={rightArrow} className="arrow-icon" />
            </div>
          </a>
          {/*<div className="contracts">*/}
          {/*  <span className="title">*/}
          {/*    <Text t="myContracts" />*/}
          {/*  </span>*/}
          {/*  <CustomImage src={rightArrow} className="arrow-icon" />*/}
          {/*</div>*/}

          <div className="footer-line" />

          <div className="footer-link-content">
            <a className="link" href={footerLink?.communication} target="_blank" rel="noreferrer">
              <Text t="communication" />
            </a>
            <a
              className="link"
              href={footerLink?.protectionOfPersonalData}
              target="_blank"
              rel="noreferrer"
            >
              <Text t="protectionPersonalData" />
            </a>
            <a className="link" href={footerLink?.cookiePolicy} target="_blank" rel="noreferrer">
              <Text t="cookiePolicy" />
            </a>
            <div
              className="link ot-sdk-show-settings"
              onClick={() => {
                window?.OneTrust?.initializeCookiePolicyHtml();
              }}
            >
              <Text t="cookieSettings" />
            </div>
          </div>

          <div className="footer-line" />
        </>
      )}
      <div style={{ display: 'none' }}>
        <b>Son Deploy Zamanı</b>
        <div
          style={{
            fontSize: 12,
          }}
        >
          {dayjs(process.DEPLOY_TIME).utc(true).utcOffset(180).toString()}
        </div>
      </div>
      <div className="footer-company-name">Ticket Online ©</div>
      <div className="all-rights-reserved">
        {dayjs().format('YYYY')} <Text t="rightsReserved" />
      </div>

      <div className="social-media-content">
        <a href={footerLink?.facebook}>
          <CustomImage src={isAdmin ? iconAdminFacebook : iconFacebook} />
        </a>
        <a href={footerLink?.instagram}>
          <CustomImage src={isAdmin ? iconAdminInstagram : iconInstagram} />
        </a>
        <a href={footerLink?.linkedin}>
          <CustomImage src={isAdmin ? iconAdminLinkedin : iconLinkedin} />
        </a>
        <a href={footerLink?.twitter}>
          <CustomImage src={isAdmin ? iconAdminTwitter : iconTwitter} />
        </a>
        <a href={footerLink?.youtube}>
          <CustomImage src={isAdmin ? iconAdminYoutube : iconYoutube} />
        </a>
      </div>
      <Select
        data-testid="languageSelect"
        defaultValue={language}
        onChange={handleChange}
        bordered={false}
        className="language-select"
        getPopupContainer={() => document.getElementById('edenred-footer')}
      >
        <Option data-testid="tr_language" value={languageOptions?.turkey}>
          <CustomImage src={iconLanguageTr} />
        </Option>
        <Option data-testid="en_language" value={languageOptions?.english}>
          <CustomImage src={iconLanguageEn} />
        </Option>
      </Select>
    </div>
  );
};

export default Footer;
